import { makeStyles, Grid, Box, Typography } from "@material-ui/core";

import { COLORS } from "../../../../theme/colors";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(8),
    marginTop: -theme.spacing(3)
  },
  separateContainer: {
    position: "relative",
    height: "100%",
  },
  separate: {
    position: "absolute",
    width: 1,
    height: 200,
    bottom: 20,
    left: 0,
    borderLeft: `1px dashed ${COLORS.darks[0][50]}`
  }
}))

export const XAxisBottom = ({labels}) => {
  const classes = useStyles();

  return (
    <Grid className={classes.root} container >
      <Grid item xs={6}>
        <Typography variant="body2" align="center">
          {labels[0]}
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Grid className={classes.separateContainer} container justifyContent="center">
          <Box className={classes.separate}></Box>
          <Typography variant="body2" align="center">
            {labels[1]}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  )
}
